import {API_ENDPOINT}  from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = process.env.REACT_APP_B2B_API_BASE_URL



export const serviceCityApi = async(data) => {
  const res = await requestInstance.get(`${env}${API_ENDPOINT.ServiceCity.api}`)
  .catch((err) => err.response);
  return setCurrentUser(res);
}

export const serviceRegionApi = async(data) => {
  const res = await requestInstance.get(`${env}${API_ENDPOINT.ServiceCity.serviceRegion +'?serviceCityId=' + data.serviceCityId}`)

  .catch((err) => err.response);
  return setCurrentUser(res);
}

export const addServiceRegionApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.ServiceCity.serviceRegion}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const subVendorRegionApi = async(data) => {
  let url = ''
  if(data?.submitterId){
    url = `${env}${API_ENDPOINT.ServiceCity.subVendorRegion+ "?subVendorId="+data?.submitterId}`
  }
  else{
    url = `${env}${API_ENDPOINT.ServiceCity.subVendorRegion}`
  }
  const res = await requestInstance.get(url)

  .catch((err) => err.response);
  return setCurrentUser(res)
}

export const addsubVendorRegionApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.ServiceCity.subVendorRegion}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};